import { render, staticRenderFns } from "./BestellingendagBase.vue?vue&type=template&id=69bee17c&scoped=true&"
import script from "./BestellingendagBase.vue?vue&type=script&lang=js&"
export * from "./BestellingendagBase.vue?vue&type=script&lang=js&"
import style0 from "./BestellingendagBase.vue?vue&type=style&index=0&id=69bee17c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bee17c",
  null
  
)

export default component.exports